function mostrarResultadoConsulta(order) {
  const resultadoDiv = document.getElementById('resultado-consulta');

  const estadoOriginalSinProcesar = order.estado;

  const estaPagada = order.estado === "PXR PAGADO" ||
    order.estado === "Pagado" ||
    order.estado === "" ||  // *** AGREGAR ESTA LÍNEA ***
    (order.estado && order.estado.includes("PXR PAGADO")) ||
    (order['Estado Pago'] && order['Estado Pago'].toLowerCase().includes('pagado'));


  if (order.estado === "" || order.estado === null || order.estado === undefined) order.estado = "Solicitud Recibida";
  else if (order.estado.includes("T�cnico") || order.estado.includes("�"))
    order.estado = order.estado.replace(/T�cnico/g, "Técnico").replace(/t�cnico/g, "técnico").replace(/�/g, "é");

  if (order["Modo de Entrega"] && (order["Modo de Entrega"].includes("T�CNICO") || order["Modo de Entrega"].includes("�")))
    order["Modo de Entrega"] = order["Modo de Entrega"].replace(/T�CNICO/g, "TÉCNICO").replace(/t�cnico/g, "técnico").replace(/�/g, "é");

  const codigoBeca = order['Código BECA'] || order['C\u00f3digo BECA'] || '';

  const ordenIdOriginal = sessionStorage.getItem('ordenIdOriginal') ||
    document.getElementById('consulta-reparacion')?.value?.trim() ||
    codigoBeca.replace(/[^\d]/g, '') ||
    codigoBeca;

  let resultado = `<h5>Estado de la Orden de Reparación</h5><div class="resultado-contenido">`;

  const camposMostrar = [
    { clave: 'estado', etiqueta: 'Estado de la orden', clase: true },
    { clave: 'Fecha de Ingreso al SSTT', etiqueta: 'Fecha de Ingreso', formatear: true },
    { clave: 'Garantía', etiqueta: 'Garantía', clase: true },
    { clave: 'RUT', etiqueta: 'Cliente' },
    { clave: 'Familia del Producto', etiqueta: 'Categoría del producto' },
    { clave: 'Nombre del Producto', etiqueta: 'Producto' },
    { clave: 'Modelo del Producto', etiqueta: 'Modelo' },
    { clave: 'Marca del Producto', etiqueta: 'Marca' },
    { clave: 'N\u00famero de Serie del Producto', etiqueta: 'Número de serie' },
    { clave: 'Número de Serie del Producto', etiqueta: 'Número de serie' },
    { clave: 'Sucursal', etiqueta: 'Adquirido en' },
    { clave: 'Fecha de Compra', etiqueta: 'Fecha de compra' },
    { clave: 'N\u00famero de Boleta', etiqueta: 'Número de boleta' },
    { clave: 'Número de Boleta', etiqueta: 'Número de boleta' },
    { clave: 'Sintoma del Producto', etiqueta: 'Síntomas reportados', parrafo: true },
    { clave: 'Direcci\u00f3n', etiqueta: 'Dirección' },
    { clave: 'Dirección', etiqueta: 'Dirección' },
    { clave: 'Ciudad', etiqueta: 'Ciudad/Comuna' },
    { clave: 'Regi\u00f3n', etiqueta: 'Región' },
    { clave: 'Región', etiqueta: 'Región' },
    { clave: 'Modo de Entrega', etiqueta: 'Entrega' },
    { clave: 'Valor Despacho', etiqueta: 'Valor Despacho', formatearMoneda: true },
    { clave: 'Valor Reparaci\u00f3n', etiqueta: 'Valor Reparación', formatearMoneda: true },
    { clave: 'Valor Reparación', etiqueta: 'Valor Reparación', formatearMoneda: true },
    { clave: 'Estado Pago', etiqueta: 'Estado de Pago', clase: true }
  ];

  const camposMostrados = new Set();
  let valorReparacion = 0, valorDespacho = 0;

  for (const campo of camposMostrar) {
    if (order[campo.clave] && !camposMostrados.has(campo.etiqueta)) {
      let valor = decodeHTMLEntities(order[campo.clave]);

      if (campo.formatear) valor = formatearFecha(valor);

      if (campo.formatearMoneda) {
        const valorNumerico = parseFloat(valor.toString().replace(/[^\d.-]/g, ''));
        if (!isNaN(valorNumerico)) {
          if (campo.etiqueta === 'Valor Reparación') valorReparacion = valorNumerico;
          else if (campo.etiqueta === 'Valor Despacho') valorDespacho = valorNumerico;
        }
        valor = isNaN(valorNumerico) ? valor : `$${valorNumerico.toLocaleString('es-CL')}`;
      }

      const claseAdicional = campo.clase ? `class="${getEstadoClase(valor)}"` : '';
      const contenido = campo.parrafo ? `<p>${valor}</p>` : `<span ${claseAdicional}>${valor}</span>`;

      resultado += `<div class="resultado-item"><strong>${campo.etiqueta}:</strong>${contenido}</div>`;
      camposMostrados.add(campo.etiqueta);
    }
  }

  const procesarCampoValor = (clave, etiqueta, valorVariable) => {
    if (!camposMostrados.has(etiqueta) && order[clave]) {
      const valorCampo = order[clave];
      const valorNumerico = parseFloat(valorCampo.toString().replace(/[^\d.-]/g, ''));
      if (!isNaN(valorNumerico)) {
        if (etiqueta === 'Valor Reparación') valorReparacion = valorNumerico;
        else if (etiqueta === 'Valor Despacho') valorDespacho = valorNumerico;
      }
      const valorFormateado = isNaN(valorNumerico) ? valorCampo : `$${valorNumerico.toLocaleString('es-CL')}`;
      resultado += `<div class="resultado-item"><strong>${etiqueta}:</strong><span>${valorFormateado}</span></div>`;
      camposMostrados.add(etiqueta);
      return true;
    }
    return false;
  };

  procesarCampoValor("Valor Reparación", "Valor Reparación", valorReparacion);
  procesarCampoValor("Valor Despacho", "Valor Despacho", valorDespacho);

  if (!camposMostrados.has('Valor Reparación')) {
    const claveReparacion = Object.keys(order).find(k =>
      k.includes('Valor') && (k.includes('Reparaci') || k.includes('Reparación') || k.includes('reparaci') || k.includes('reparación')));
    if (claveReparacion && order[claveReparacion]) {
      procesarCampoValor(claveReparacion, "Valor Reparación", valorReparacion);
    }
  }

  if (!camposMostrados.has('Valor Despacho')) {
    const claveDespacho = Object.keys(order).find(k => k.includes('Valor') && (k.includes('Despacho') || k.includes('despacho')));
    if (claveDespacho && order[claveDespacho]) {
      procesarCampoValor(claveDespacho, "Valor Despacho", valorDespacho);
    }
  }

  const valorTotal = valorReparacion + valorDespacho;
  
  // Guardar datos del cliente en sessionStorage para usarlos en el pago
  const rut = order['RUT'] || '';
  const nombre = order['Nombre'] || order['Nombre Cliente'] || order['Cliente'] || order['Nombre del Cliente'] || '';
  // Buscar dirección con diferentes encodings posibles
  const direccion = order['Dirección'] || order['Direcci\u00f3n'] || order['Direcci�n'] || '';
  const ciudad = order['Ciudad'] || '';
  // Buscar región con diferentes encodings posibles
  const region = order['Región'] || order['Regi\u00f3n'] || order['Regi�n'] || '';
  
  console.log('=== DATOS DE INES V4 ===');
  console.log('RUT:', rut);
  console.log('Nombre:', nombre);
  console.log('Dirección:', direccion);
  console.log('Ciudad:', ciudad);
  console.log('Región:', region);
  console.log('=== TODOS LOS CAMPOS DE INES ===');
  console.log(JSON.stringify(order, null, 2));
  
  if (rut) sessionStorage.setItem('ordenRut', rut);
  if (nombre) sessionStorage.setItem('ordenNombre', nombre);
  if (direccion) sessionStorage.setItem('ordenDireccion', direccion);
  if (ciudad) sessionStorage.setItem('ordenCiudad', ciudad);
  if (region) sessionStorage.setItem('ordenRegion', region);
  
  console.log('SessionStorage guardado:');
  console.log('- ordenDireccion:', sessionStorage.getItem('ordenDireccion'));
  console.log('- ordenCiudad:', sessionStorage.getItem('ordenCiudad'));
  console.log('- ordenRegion:', sessionStorage.getItem('ordenRegion'));

  if (valorTotal > 0 && !estaPagada) {
    resultado += `
     <div class="email-pago-container">
       <label for="nombre-pago" style="color: #666; font-weight: bold;">Nombre completo:</label>
       <input type="text" id="nombre-pago" value="" placeholder="Ingrese su nombre completo" style="margin-bottom: 10px;">
       <label for="email-pago" style="color: #666; font-weight: bold;">Correo electrónico para el pago:</label>
       <input type="email" id="email-pago" value="" placeholder="Ingrese su correo electrónico">
     </div>
     <div style="display:flex; align-items:center; justify-content:space-between; margin:15px 0; padding:15px; border:1px solid #d0d0d0; border-radius:6px; background-color:#f5f8ff;">
       <div style="display:flex; align-items:center;">
         <strong>Valor a pagar:</strong>
         <span style="font-weight:700; color:#bd2d34; margin-left:10px;">$${valorTotal.toLocaleString('es-CL')}</span>
       </div>
       <div id="contenedor-boton-pago">
         <button type="button" class="btn-pagar" onclick="iniciarPagoFlow('${ordenIdOriginal}', ${valorTotal}, document.getElementById('email-pago').value, document.getElementById('nombre-pago').value)">Pagar con Flow</button>
       </div>
     </div>
   `;
  } else if (valorTotal > 0 && estaPagada) {
    resultado += `
     <div style="margin:15px 0; padding:15px; border:1px solid #66bb6a; border-radius:6px; background-color:#e8f5e9; display:flex; align-items:center;">
       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:15px;">
         <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
         <polyline points="22 4 12 14.01 9 11.01"></polyline>
       </svg>
       <div>
         <strong style="color:#2e7d32; font-size:16px;">Pago realizado correctamente</strong>
         <p style="margin:5px 0 0; color:#2e7d32;">Valor pagado: $${valorTotal.toLocaleString('es-CL')}</p>
       </div>
     </div>
   `;
  }

  if (order.productImage || order.imagen_producto)
    resultado += `<div class="resultado-item"><strong>Imagen del producto:</strong><div class="imagen-contenedor producto-imagen-container fade-in"><img src="${order.productImage || order.imagen_producto}" alt="Imagen del producto" style="max-height:150px;"></div></div>`;

  if (order.boletaImage || order.imagen_boleta)
    resultado += `<div class="resultado-item"><strong>Imagen de la boleta:</strong><div class="imagen-contenedor fade-in"><img src="${order.boletaImage || order.imagen_boleta}" alt="Imagen de la boleta" style="max-height:150px;"></div></div>`;

  resultado += `
   <div class="consulta-botones">
     <button type="button" class="btn-secundario" onclick="resetearFormularios()">Volver</button>
     <button type="button" class="btn-enviar" onclick="document.getElementById('btn-ingresar').click()">Ingresar Nueva Orden</button>
   </div>
 </div>`;

  resultadoDiv.innerHTML = resultado;

  const urlParams = new URLSearchParams(window.location.search);
  const status = urlParams.get('status');
  const orden = urlParams.get('orden');

  if (status === 'completed' && orden) {
    const mensajeExito = document.createElement('div');
    mensajeExito.className = 'pago-exitoso-mensaje';
    mensajeExito.innerHTML = `
     <div style="background-color: #e8f5e9; border: 1px solid #66bb6a; border-radius: 8px; padding: 20px; margin: 20px 0; text-align: center;">
       <h3 style="color: #2e7d32; margin-top: 0;">¡Pago Realizado con Éxito!</h3>
       <p>Tu orden <strong>${orden}</strong> ha sido procesada correctamente.</p>
       <p>Hemos enviado un comprobante a tu correo electrónico.</p>
     </div>
   `;

    resultadoDiv.prepend(mensajeExito);
    mensajeExito.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else if (status && status !== 'completed' && orden) {
    const mensajeError = document.createElement('div');
    mensajeError.className = 'pago-error-mensaje';
    mensajeError.innerHTML = `
     <div style="background-color: #ffebee; border: 1px solid #f44336; border-radius: 8px; padding: 20px; margin: 20px 0; text-align: center;">
       <h3 style="color: #d32f2f; margin-top: 0;">Operación Anulada</h3>
       <p>El pago para la orden <strong>${orden}</strong> fue cancelado o no se pudo procesar.</p>
       <p>Puedes intentar realizar el pago nuevamente si lo deseas.</p>
     </div>
   `;

    resultadoDiv.prepend(mensajeError);
    mensajeError.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function obtenerClienteEmail() {
  // Primero intentar obtener del campo de pago si existe
  const emailPagoCampo = document.getElementById('email-pago');
  if (emailPagoCampo && emailPagoCampo.value.trim()) {
    return emailPagoCampo.value.trim();
  }
  // Si no, del formulario de ingreso
  const emailCampo = document.getElementById('cliente-email');
  return emailCampo ? emailCampo.value : null;
}

function iniciarPagoFlow(ordenId, monto, email, nombre) {
  // Limpiar datos de pagos anteriores
  sessionStorage.removeItem('pagoEmail');
  sessionStorage.removeItem('pagoNombre');
  sessionStorage.removeItem('pagoMonto');
  sessionStorage.removeItem('pagoOrdenId');
  // Limpiar flag de orden creada para permitir nuevo intento
  if (ordenId) {
    sessionStorage.removeItem('ordenShopifyCreada_' + ordenId);
  }

  const nombreInput = document.getElementById('nombre-pago');
  const nombreValue = nombreInput ? nombreInput.value.trim() : '';
  const emailInput = document.getElementById('email-pago');
  const emailValue = emailInput ? emailInput.value.trim() : '';

  // Validar nombre completo (debe tener al menos nombre y apellido)
  if (!nombreValue) {
    alert('Por favor ingrese su nombre completo para continuar con el pago.');
    if (nombreInput) {
      nombreInput.focus();
      nombreInput.classList.add('campo-error');
      nombreInput.addEventListener('input', function () {
        this.classList.remove('campo-error');
      }, { once: true });
    }
    return;
  }

  const palabrasNombre = nombreValue.trim().split(/\s+/);
  if (palabrasNombre.length < 2) {
    alert('Por favor ingrese su nombre y apellido completo (ejemplo: Juan Pérez).');
    if (nombreInput) {
      nombreInput.focus();
      nombreInput.classList.add('campo-error');
      nombreInput.addEventListener('input', function () {
        this.classList.remove('campo-error');
      }, { once: true });
    }
    return;
  }

  if (!emailValue) {
    alert('Por favor ingrese un correo electrónico para continuar con el pago.');
    if (emailInput) {
      emailInput.focus();
      emailInput.classList.add('campo-error');
      emailInput.addEventListener('input', function () {
        this.classList.remove('campo-error');
      }, { once: true });
    }
    return;
  }

  const botonPagar = document.querySelector('.btn-pagar');
  const contenedorBotonPago = document.getElementById('contenedor-boton-pago');

  if (botonPagar) {
    botonPagar.disabled = true;
    botonPagar.style.display = 'none';
  }

  const spinnerContainer = document.createElement('div');
  spinnerContainer.className = 'cargando-pago-container';
  spinnerContainer.innerHTML = `<div class="cargando-pago-spinner"></div><span class="cargando-pago-text">Conectando con Flow...</span>`;
  contenedorBotonPago.appendChild(spinnerContainer);

  const montoTotal = monto;
  const montoFinal = montoTotal;
  
  console.log('=== DATOS DE PAGO ===');
  console.log('Monto original:', monto);
  console.log('Monto final:', montoFinal);
  console.log('Tipo de monto:', typeof montoFinal);

  const commerceOrder = ordenId && ordenId.trim() !== '' ?
    ordenId + '-' + Date.now() + '-' + Math.floor(Math.random() * 1000) :
    'ST-' + Math.floor(10000 + Math.random() * 90000) + '-' + Date.now();

  const csrfToken = Date.now().toString(36) + Math.random().toString(36).substring(2);
  sessionStorage.setItem('flowCsrfToken', csrfToken);

  const emailFinal = emailValue;
  const nombreFinal = nombreValue;
  const rutCliente = sessionStorage.getItem('ordenRut') || '';
  const direccionCliente = sessionStorage.getItem('ordenDireccion') || '';
  const ciudadCliente = sessionStorage.getItem('ordenCiudad') || '';
  const regionCliente = sessionStorage.getItem('ordenRegion') || '';
  
  console.log('=== DATOS ANTES DE ENVIAR A FLOW ===');
  console.log('Email:', emailFinal);
  console.log('Nombre:', nombreFinal);
  console.log('RUT:', rutCliente);
  console.log('Dirección:', direccionCliente);
  console.log('Ciudad:', ciudadCliente);
  console.log('Región:', regionCliente);

  const paymentData = {
    commerceOrder: commerceOrder,
    subject: 'Pago Servicio Técnico - Orden: ' + commerceOrder,
    currency: 'CLP',
    amount: montoFinal,
    email: emailFinal,
    urlConfirmation: 'https://app.alcachofa.cl/flow-confirm.php',
    urlReturn: 'https://app.alcachofa.cl/redirect.html?status=completed&orden=' + ordenId + '&email=' + encodeURIComponent(emailFinal) + '&amount=' + montoFinal,
    optional: {
      orden_id: commerceOrder,
      csrf_token: csrfToken
    },
    timeout: 600
  };

  const textElement = spinnerContainer.querySelector('.cargando-pago-text');
  if (textElement) textElement.textContent = 'Generando orden de pago...';

  setTimeout(() => {
    console.log('=== ENVIANDO A FLOW ===');
    console.log('Datos completos:', JSON.stringify(paymentData, null, 2));
    console.log('Amount en paymentData:', paymentData.amount);
    fetch('https://app.alcachofa.cl/flow-payment.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(paymentData)
    })
      .then(response => {
        if (!response.ok) throw new Error('Error en la respuesta del servidor: ' + response.status);
        if (textElement) textElement.textContent = 'Orden generada. Preparando redirección...';
        return response.json();
      })
      .then(data => {
        if (data.url) {
          sessionStorage.setItem('flowLastTransaction', JSON.stringify({
            order: commerceOrder,
            amount: montoFinal,
            timestamp: Date.now()
          }));

          // Guardar email, nombre y monto para usarlos después del pago
          sessionStorage.setItem('pagoEmail', emailFinal);
          sessionStorage.setItem('pagoNombre', nombreFinal);
          sessionStorage.setItem('pagoMonto', montoFinal.toString());
          sessionStorage.setItem('pagoOrdenId', ordenId);

          if (textElement) textElement.textContent = 'Redirigiendo al portal de pagos...';
          setTimeout(() => { window.location.href = data.url; }, 1000);
        } else {
          const errorMsg = data.error || data.message || 'Error desconocido';
          mostrarError('Error al iniciar el pago: ' + errorMsg);
        }
      })
      .catch(error => mostrarError('Error al conectar con el servidor de pagos: ' + error.message));
  }, 800);
}

function mostrarError(mensaje) {
  const contenedorBotonPago = document.getElementById('contenedor-boton-pago');
  const spinnerContainer = contenedorBotonPago ? contenedorBotonPago.querySelector('.cargando-pago-container') : null;

  if (spinnerContainer) spinnerContainer.remove();

  const botonPagar = document.querySelector('.btn-pagar');
  if (botonPagar) {
    botonPagar.disabled = false;
    botonPagar.style.display = 'inline-flex';
  }

  const errorDiv = document.createElement('div');
  errorDiv.className = 'error-pago';
  errorDiv.innerHTML = `<p class="error-mensaje"><strong>Error:</strong> ${mensaje}</p><button type="button" class="btn-reintentar">Reintentar</button>`;

  if (contenedorBotonPago) contenedorBotonPago.parentNode.appendChild(errorDiv);
  else document.getElementById('resultado-consulta').appendChild(errorDiv);

  const btnReintentar = errorDiv.querySelector('.btn-reintentar');
  if (btnReintentar) btnReintentar.addEventListener('click', function () {
    errorDiv.remove();
    iniciarPagoFlow(ordenId, monto, email);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const status = urlParams.get('status');
  const orden = urlParams.get('orden');
  const token = urlParams.get('token');
  const hasRefreshed = sessionStorage.getItem('hasRefreshed');

  if (status === 'completed' && orden && !hasRefreshed) {
    console.log("Auto-refrescando la página para completar la redirección de pago...");

    sessionStorage.setItem('ordenPagada', orden);
    sessionStorage.setItem('hasRefreshed', 'true');

    setTimeout(function () {
      window.location.reload();
    }, 1000);
    return;
  }

  if (status === 'completed' && orden) {
    sessionStorage.removeItem('hasRefreshed');

    // Extraer solo el ID de la orden (primera parte antes del guion)
    const ordenId = orden.split('-')[0];
    const ordenPagada = sessionStorage.getItem('ordenPagada') || ordenId;

    // Verificar si ya se creó la orden en Shopify para evitar duplicados
    const ordenShopifyCreada = sessionStorage.getItem('ordenShopifyCreada_' + ordenId);
    if (ordenShopifyCreada) {
      console.log("=== ORDEN YA CREADA EN SHOPIFY - SALTANDO ===");
      console.log("Orden ID:", ordenId);
      return;
    }

    // Obtener email, nombre y monto de la URL o sessionStorage
    const emailPago = urlParams.get('email') || sessionStorage.getItem('pagoEmail') || '';
    const nombrePago = urlParams.get('name') || sessionStorage.getItem('pagoNombre') || '';
    const montoPago = urlParams.get('amount') || sessionStorage.getItem('pagoMonto') || '0';
    const rutPago = sessionStorage.getItem('ordenRut') || '';
    const direccionPago = sessionStorage.getItem('ordenDireccion') || '';
    const ciudadPago = sessionStorage.getItem('ordenCiudad') || '';
    const regionPago = sessionStorage.getItem('ordenRegion') || '';

    console.log("=== CREANDO ORDEN EN SHOPIFY ===");
    console.log("Orden ID:", ordenId);
    console.log("Email recuperado:", emailPago);
    console.log("Nombre recuperado:", nombrePago);
    console.log("Monto recuperado:", montoPago);
    console.log("RUT recuperado:", rutPago);
    console.log("Dirección recuperada:", direccionPago);
    console.log("Ciudad recuperada:", ciudadPago);
    console.log("Región recuperada:", regionPago);

    // Marcar la orden como procesándose
    sessionStorage.setItem('ordenShopifyCreada_' + ordenId, 'true');

    // Primero crear la orden en Shopify
    crearOrdenShopify(ordenId, emailPago, montoPago, nombrePago, rutPago, direccionPago, ciudadPago, regionPago)
      .then(shopifyResult => {
        console.log("Resultado creación Shopify:", shopifyResult);
        
        // LOG 1: Guardar log de creación Shopify
        fetch('https://app.alcachofa.cl/save-log.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            type: 'create-shopify',
            ot_id: ordenId,
            email: emailPago,
            log_data: {
              nombre: nombrePago,
              rut: rutPago,
              monto: montoPago,
              direccion: direccionPago,
              ciudad: ciudadPago,
              region: regionPago,
              shopify_response: shopifyResult
            }
          })
        }).catch(e => console.log('Error guardando log create-shopify:', e));
        
        // Luego actualizar estado en INES
        return actualizarEstadoOrden(ordenPagada);
      })
      .then(result => {
        console.log("Estado actualizado a PXR PAGADO:", result);
        
        // LOG 2: Guardar log de actualización INES
        fetch('https://app.alcachofa.cl/save-log.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            type: 'update-ines',
            ot_id: ordenId,
            email: emailPago,
            log_data: {
              estado: 'PXR PAGADO',
              monto: montoPago,
              ines_response: result
            }
          })
        }).catch(e => console.log('Error guardando log update-ines:', e));
        
        // Limpiar datos del pago después de completar
        sessionStorage.removeItem('pagoEmail');
        sessionStorage.removeItem('pagoNombre');
        sessionStorage.removeItem('pagoMonto');
        sessionStorage.removeItem('pagoOrdenId');
        sessionStorage.removeItem('ordenPagada');
        // Mantener el flag de orden creada para evitar duplicados en futuras consultas
      })
      .catch(error => {
        console.error("Error en el proceso:", error);
        // Si hubo error, limpiar el flag para permitir reintentar
        sessionStorage.removeItem('ordenShopifyCreada_' + ordenId);
      });

    console.log("Mostrando mensaje de pago exitoso para la orden:", orden);

    const mensajeExito = document.createElement('div');
    mensajeExito.className = 'pago-exitoso-mensaje';
    mensajeExito.innerHTML = `
     <div style="background-color: #e8f5e9; border: 1px solid #66bb6a; border-radius: 8px; padding: 20px; margin: 20px 0; text-align: center;">
       <h3 style="color: #2e7d32; margin-top: 0;">¡Pago Realizado con Éxito!</h3>
       <p>Tu orden <strong>${orden}</strong> ha sido procesada correctamente.</p>
       <p>Hemos enviado un comprobante a tu correo electrónico.</p>
       <button class="btn-enviar" onclick="window.location.href='/pages/servicio-tecnico'">Aceptar</button>
     </div>
   `;

    const contenedor = document.querySelector('.page-width') || document.body;
    if (contenedor) {
      const primerElemento = contenedor.firstChild;
      contenedor.insertBefore(mensajeExito, primerElemento);

      mensajeExito.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  } else if ((status === 'cancelled' || status === 'failed' || status === 'rejected') && orden) {
    console.log("Mostrando mensaje de operación anulada para la orden:", orden);

    const mensajeError = document.createElement('div');
    mensajeError.className = 'pago-error-mensaje';
    mensajeError.innerHTML = `
     <div style="background-color: #ffebee; border: 1px solid #f44336; border-radius: 8px; padding: 20px; margin: 20px 0; text-align: center;">
       <h3 style="color: #d32f2f; margin-top: 0;">Operación Anulada</h3>
       <p>El pago para la orden <strong>${orden}</strong> fue cancelado o no se pudo procesar.</p>
       <p>Puedes intentar realizar el pago nuevamente si lo deseas.</p>
       <button class="btn-enviar" onclick="window.location.href='/pages/servicio-tecnico'">Aceptar</button>
     </div>
   `;

    const contenedor = document.querySelector('.page-width') || document.body;
    if (contenedor) {
      const primerElemento = contenedor.firstChild;
      contenedor.insertBefore(mensajeError, primerElemento);

      mensajeError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
});

function crearOrdenShopify(ordenId, email, monto, nombre, rut, direccion, ciudad, region) {
  if (!ordenId) {
    console.error('No se proporcionó un ID de orden válido');
    return Promise.reject('ID de orden inválido');
  }

  // Validar que nombre tenga al menos 2 palabras antes de enviar
  if (!nombre || nombre.trim().split(/\s+/).length < 2) {
    console.error('Nombre debe incluir nombre y apellido:', nombre);
    return Promise.reject('Nombre inválido: debe incluir nombre y apellido');
  }

  console.log("Creando orden en Shopify:", ordenId, email, monto, nombre, rut, direccion, ciudad, region);

  const shopifyData = {
    ot_id: ordenId,
    customer_email: email || `sin-email-${ordenId}@thorbenstore.cl`,
    customer_name: nombre,
    valor_total: parseFloat(monto) || 0,
    customer_rut: rut || '',
    customer_direccion: direccion || '',
    customer_ciudad: ciudad || '',
    customer_region: region || ''
  };

  console.log("Datos para Shopify:", shopifyData);

  return fetch('https://app.alcachofa.cl/create-shopify-order.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(shopifyData)
  })
    .then(response => response.json())
    .then(result => {
      console.log('Respuesta de Shopify:', result);
      return result;
    })
    .catch(error => {
      console.error('Error creando orden Shopify:', error);
      throw error;
    });
}

function actualizarEstadoOrden(ordenId) {
  if (!ordenId) {
    console.error('No se proporcionó un ID de orden válido');
    return Promise.reject('ID de orden inválido');
  }

  console.log("Actualizando estado de orden a Pagado:", ordenId);

  const updateData = {
    orden_id: ordenId,
    estado: 'PXR PAGADO'
  };

  return fetch('https://ssttbeca.ines.cl/ssttbeca/update.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updateData)
  })
    .then(response => response.text())
    .then(data => {
      console.log('Respuesta de actualización:', data);
      try {
        return JSON.parse(data);
      } catch (e) {
        console.log('No se pudo parsear como JSON:', e);
        if (data.includes('actualizada') || data.includes('success')) {
          return { success: true, message: data };
        }
        return { success: false, message: data };
      }
    });
}